export default __webpack_public_path__ + "static/media/move.4c3931ff.svg";